import BaseService from '../base.service'
export default class SolidService extends BaseService {
  backendSolidBaseUrl
  constructor() {
    super();
    this.backendSolidBaseUrl = this.baseURL + '/solid/v1'
  }
}